import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { Radio, Space } from 'antd'
import useOutsideClick from '../../../../hooks/useOutsideClick'
import { Package } from 'lucide-react'

export function ProductFilter({ product, setProduct, products }) {
  const [openProductFilter, setOpenProductFilter] = useState(false)
  const productFilterRef = useRef(null)

  useOutsideClick(productFilterRef, () => {
    if (productFilterRef) {
      setOpenProductFilter(false)
    }
  })

  return (
    <div className="relative" ref={productFilterRef}>
      <button className="flex items-center gap-[8px] px-[12px]" onClick={() => setOpenProductFilter(!openProductFilter)}>
        <Package size={20} className="text-[#40424A]" />
        <p className="text-[#41434B] text-[16px] font-medium font-['Manrope']">
          {product === '' ? 'Any Product' : products.find(p => p.id === product)?.name || 'Any Product'}
        </p>
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_3983_17643)">
            <circle cx="9.88218" cy="9.82065" r="7.27964" fill="#EBEBEB"/>
            <path d="M12.3082 9.01367L9.88162 11.4402L7.45508 9.01367" stroke="#40424A" strokeWidth="1.3866" strokeLinecap="round" strokeLinejoin="round"/>
          </g>
          <defs>
            <clipPath id="clip0_3983_17643">
              <rect width="19.4124" height="19.4124" fill="white" transform="translate(0.175781 0.115234)"/>
            </clipPath>
          </defs>
        </svg>
      </button>
      {openProductFilter && (
        <div className="absolute w-auto left-[-1px] top-8 p-2 bg-white shadow rounded-b border-x border-grey-200 z-50">
          <Radio.Group onChange={(e) => setProduct(e.target.value)} value={product}>
            <Space direction="vertical">
              <Radio value={''}>Any Product</Radio>
              {products.map((p) => (
                <Radio key={p.id} value={p.id}>{p.name}</Radio>
              ))}
            </Space>
          </Radio.Group>
        </div>
      )}
    </div>
  )
}

ProductFilter.propTypes = {
  product: PropTypes.string,
  setProduct: PropTypes.func,
  products: PropTypes.array
} 